tarteaucitron.init({
    "privacyUrl": "", /* Privacy policy url */

    "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
    "cookieName": "tarteaucitron", /* Cookie name */

    "orientation": "bottom", /* Banner position (top - bottom) */

    "showAlertSmall": false, /* Show the small banner on bottom right */
    "cookieslist": true, /* Show the cookie list */

    "showIcon": false, /* Show cookie icon to manage cookies */
    "iconPosition": "BottomRight", /* BottomRight, BottomLeft, TopRight and TopLeft */

    "adblocker": false, /* Show a Warning if an adblocker is detected */

    "DenyAllCta" : true, /* Show the deny all button */
    "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
    "highPrivacy": true, /* Disable auto consent */

    "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

    "removeCredit": true, /* Remove credit link */
    "moreInfoLink": false, /* Show more info link */
    "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */

    "readmoreLink": "", /* Change the default readmore link */

    "mandatory": false, /* Show a message about mandatory cookies */
});

// Calameo
tarteaucitron.services.calameoLibrary = {
    "key": "calameoLibrary",
    "type": "video",
    "name": "Bibliothèques Calaméo",
    "uri": "",
    "needConsent": true,
    "cookies": [],
    "js": function (elem) {
        "use strict";
        tarteaucitron.fallback(['calameoLibrary'], function (x) {
            var width = x.getAttribute("width"),
                height = x.getAttribute("data-height"),
                url = x.getAttribute("data-url");

            return '<iframe src="' + url + '" width="' + width + '" height="' + height + '" frameborder="0" scrolling="no" allowtransparency allowfullscreen></iframe>';
        });
    },
    "fallback": function () {
        "use strict";
        var id = 'calameoLibrary';
        tarteaucitron.fallback(['calameoLibrary'], function (elem) {
            elem.style.width = elem.getAttribute('width') + 'px';
            elem.style.height = elem.getAttribute('height') + 'px';
            return tarteaucitron.engage(id);
        });
    }
};

// Matomo Tag Manager
tarteaucitron.services.matomotagmanager = {
  "key": "matomotagmanager",
  "type": "analytic",
  "name": "Matomo Tag Manager",
  "uri": "https://matomo.org/faq/general/faq_146/",
  "needConsent": false,
  "cookies": ['_pk_ref', '_pk_cvar', '_pk_id', '_pk_ses', '_pk_hsr', 'piwik_ignore', '_pk_uid'],
  "js": function () {
      "use strict";

      if (tarteaucitron.user.mtmId === undefined) {
        return;
      }

      var _mtm = window._mtm = window._mtm || [];
      _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.src=tarteaucitron.user.mtmHost + '/js/container_' + tarteaucitron.user.mtmId + '.js'; s.parentNode.insertBefore(g,s);
  }
};

(tarteaucitron.job = tarteaucitron.job || []).push('youtube');
(tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
//(tarteaucitron.job = tarteaucitron.job || []).push('calameo');
(tarteaucitron.job = tarteaucitron.job || []).push('calameoLibrary');
